import React, {useState} from 'react';
import {Table} from 'antd';
import {PageFooterNav} from '../crm/common/page-footer-nav';
import {normalizePhone} from '../../../utils/normalize-phone';

export function AdminUsers({ users, onRemove }) {
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(50);
  const [filters, setFilters] = useState({ phone: null });


  let items = users;
  if (filters.phone) {
    let filterPhone = filters.phone.trim();
    if (filterPhone.startsWith('+7')) {
      filterPhone = filterPhone.slice(2);
    }
    const regex = new RegExp(filterPhone, 'i');
    items = items.filter(i => regex.test(normalizePhone(i.phone)));
  }

  items =  items.slice(page * pageSize - pageSize, page * pageSize);

  const columns = [
    {
      title: 'ФИО',
      dataIndex: 'name',
      key: 'name',
      render: text => <span>{text}</span>,
    },
    {
      title: 'Телефон',
      dataIndex: 'phone',
      key: 'phone',
      render: text => <span>+7{text}</span>
    },
    {
      title: 'Email',
      dataIndex: 'email',
      key: 'email',
    },
    {
      title: 'Пароль',
      dataIndex: 'password',
      key: 'password',
    },
    {
      title: 'Всего машин',
      dataIndex: 'totalCars',
      key: 'totalCars',
    },
    {
      title: 'Действие',
      key: 'action',
      render: (text, record) => (
        <span>
          <a onClick={() => onRemove(record)}>Удалить</a>
        </span>
      ),
    },
  ];

  return (
    <div>
      <Table columns={columns} dataSource={items} pagination={false} />
      <PageFooterNav
        page={page}
        pageSize={pageSize}
        total={users.length}
        onChangePagination={(page, pageSize) => {
          setPage(page);
          setPageSize(pageSize);
        }}

        filters={filters}
        patchFilters={data => setFilters({ ...filters, ...data })}
        filtersEnabled={['phone']}
        applyFilters={() => {}}
      />
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/pages/admin/users.js